/**
 * Fix C1 (F-25, CLAUDE.md section 10). The model reads a contact's own name or
 * handle as the contact's pseudonym (`CUST_0417`) and contact details as the
 * bracketed tokens of `MODEL_MASK` (contactMask.ts), and the shop's own turns
 * in the window carry the same tokens. The verifier refuses any reply that
 * repeats one (`model_mask_token`), so with no line saying what they are, "hi
 * it's CUST_0001" invites "Hi CUST_0001!", a first-pass rejection and a
 * corrective retry: first-pass metrics drop for a reason that is ours.
 *
 * One line for every composer whose prompt can carry masked customer text (the
 * reply agent's compose prompt, the public review response). Not for a prompt
 * whose output is facts rather than a reply (the extract prompt). Single line,
 * no dash of any kind (section 12). Pinned by `maskPlaceholderRule.test.ts` and
 * `packages/agents/src/maskPlaceholderPrompts.test.ts`.
 */
export const MASK_PLACEHOLDER_RULE =
  "Names in this conversation appear as ids like CUST_0001, and contact details as [phone], [email] or [address]. " +
  "These are placeholders for the shop's records, so never write one into a reply, and address the customer without a name.";
